const month = 2592000000;

const periods = [
    {name: '6 месяцев', value: month * 6},
    {name: '1 год', value: month * 12},
    {name: '2 года', value: month * 24},
    {name: '3 года', value: month * 36},
    {name: '4 года', value: month * 48},
    {name: '5 лет', value: month * 60}
];

export function getPeriods() {
    return periods;
}

export function convertLongToPeriod(val) {
    let rsl = null;
    periods.forEach(period => {
        if (period.value === val) {
            rsl = period
        }
    })
    return rsl;
}